import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import "./GameLevelToggle.css";

export default function GameLevelToggle({ labels, option, setOption }) {
  const handleChange = (event, newValue) => {
    if (newValue === null) return;
    setOption(newValue);
  };

  return (
    <ToggleButtonGroup color="primary" value={option} exclusive onChange={handleChange} className="game-level-toggle">
      {labels.map(({ value, label, color, icon }) => (
        <ToggleButton
          key={value}
          value={value}
          style={{ backgroundColor: option === value ? color : "#f0f0f0", color: option === value ? "#fff" : "#333" }}
        >
          <span style={{ marginRight: "6px" }}>{icon}</span> {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
